/**
 * Дизайн-токены ПРОФСПОРТСРМ — компактная SaaS-шкала.
 *
 * Цвета сохранены из макета; размеры и типографика уменьшены (~30–35%)
 * относительно исходного переноса PDF 1920px, чтобы UI не выглядел
 * «режимом для слабовидящих». При правках плотности меняется этот файл.
 */

export const colors = {
  /** Основной синий: заголовки, кнопки, активные элементы. */
  primary: '#2F6BFF',
  /** Тёмный синий — тень/градиент под primary. */
  primaryDark: '#0D4BD7',
  /** Светлый синий — фон ячеек календаря, заголовки таблиц. */
  primarySoft: '#BFD3FF',

  /** Фон страницы и полей ввода. */
  surface: '#F5F6FA',
  /** Фон карточек. */
  card: '#FFFFFF',

  /** Основной текст. */
  text: '#202224',
  /** Второстепенный текст, подписи полей. */
  textMuted: '#404040',
  /** Подсказки, placeholder. */
  textHint: '#8B8C8F',
  /** Мелкие пояснения под полями. */
  textFaint: '#838385',
  /** Текст пустых состояний. */
  textEmpty: '#5D5D5D',
  /** Подписи в карточках быстрых действий. */
  textSubtle: '#666666',

  /** Границы полей ввода. */
  border: '#838385',
  /** Границы неактивных полей. */
  borderDisabled: '#E3E3E3',
  /** Разделители, выделение строки в выпадающем списке. */
  divider: '#D9D9D9',
  /** Фон строк расписания. */
  rowAlt: '#EFEFEF',
  rowMuted: '#C0C0C0',

  /** Ошибка / предупреждение. */
  danger: '#F93C65',
  /** Успех, прогресс. */
  success: '#00B69B',

  white: '#FFFFFF',
  /** Затемнение фона в состоянии «ожидайте подтверждения». */
  overlay: '#D9D9D9',

  /** Тёмный navy сайдбара кабинета (md+). */
  sidebar: '#1B2438',
  sidebarMuted: 'rgba(255,255,255,0.62)',
  sidebarSoft: 'rgba(255,255,255,0.08)',
} as const;

/** Радиусы — компактная шкала. */
export const radii = {
  /** Карточки авторизации. */
  card: 16,
  /** Карточки дашборда / диалоги. */
  panel: 16,
  /** Кнопки. */
  button: 10,
  /** Поля ввода — полная пилюля. */
  pill: 999,
  /** Выпадающий список. */
  dropdown: 12,
  /** Ячейки календаря. */
  cell: 8,
} as const;

/**
 * Размеры элементов управления (компактный SaaS).
 * На узких экранах уменьшаются через responsive-значения типографики.
 */
export const sizes = {
  /** Высота поля ввода. */
  fieldHeight: 48,
  fieldHeightSm: 40,
  /** Кнопка. */
  buttonHeight: 44,
  buttonHeightSm: 40,
  buttonMinWidth: 140,
  /** Ширина карточки авторизации. */
  authCardWidth: 480,
  /** Ширина карточки выбора организации. */
  selectCardWidth: 720,
  /** Ширина карточки регистрации партнёра. */
  registerCardWidth: 900,
  /** Ширина бокового меню. */
  sidebarWidth: 248,
} as const;

/** Типографика — компактная иерархия. */
export const typography = {
  /** Заголовок экрана входа. */
  authTitle: { xs: 22, sm: 28, md: 32 },
  /** Крупный вопрос/секция (выбор организации). */
  sectionTitle: { xs: 18, sm: 22, md: 26 },
  /** Заголовок страницы кабинета. */
  pageTitle: { xs: 20, sm: 24, md: 28 },
  /** Значения KPI. */
  metric: { xs: 24, sm: 28, md: 34 },
  /** Заголовки панелей. */
  panelTitle: { xs: 15, sm: 16, md: 18 },
  /** Текст в полях ввода. */
  field: { xs: 14, sm: 14, md: 15 },
  /** Текст на кнопках. */
  button: { xs: 14, sm: 14, md: 15 },
  /**
   * Стандартный размер UI-текста кабинета (эталон — свитчер спортсменов / аккаунта).
   * Подписи, пункты меню, чекбоксы, вторичные строки в таблицах.
   */
  label: { xs: 13, sm: 13, md: 14 },
  /** Мелкие пояснения (роль в свитчере, подсказки). */
  hint: { xs: 12, sm: 12, md: 13 },
} as const;

/** Длительности анимаций переходов между шагами авторизации. */
export const motion = {
  stepDuration: 340,
  fadeDuration: 220,
  easing: 'cubic-bezier(0.22, 0.61, 0.36, 1)',
} as const;
